import { forwardRef } from 'react';
import { Box } from 'styled-system/jsx';
import { MainDetailCardPropsType } from '@/common/components/DetailCard/DetailCard.types.ts';

const MainDetailCard = forwardRef<HTMLDivElement, MainDetailCardPropsType>(
  ({ className, children, ...props }, ref) => {
    return (
      <Box
        ref={ref}
        backgroundColor="white"
        borderRadius="8px"
        shadow="cardShadow"
        className={className}
        {...props}
      >
        {children}
      </Box>
    );
  },
);

MainDetailCard.displayName = 'MainDetailCard';

export default MainDetailCard;
